import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { isEmpty } from 'lodash-es'

import { useAllServiceClassificationsByCategory } from 'utils/api/hooks'
import TitleWithRemark from 'components/common/TitleWithRemark'
import { HideInMobileBox } from 'components/common/Hidden'
import LinkItem from './LinkItem'
import HelfSplitGrid from './HelfSplitGrid'

const DesktopServiceItem = ({ selfConstruct, onSyServiceClick }) => {
  const {
    houseCleaningData,
    deviceCleaningData,
    relocationData,
    decorationData,
  } = useAllServiceClassificationsByCategory(selfConstruct?.active)

  return (
    <Box display="flex" flexDirection="column">
      <TitleWithRemark variant="subtitle1" my={4}>
        <HideInMobileBox component="span">熱門</HideInMobileBox>服務
      </TitleWithRemark>
      <Divider />

      <HelfSplitGrid>
        <Box my={7.5}>
          {houseCleaningData.map((data, idx) => (
            <LinkItem
              key={`house-clean-${idx}`}
              href={`/vender?serviceItem=${data?._id}`}
              $isFirst={idx === 0}
            >
              {data.name}
            </LinkItem>
          ))}
          <Box color="text.minus2" my={5}>
            -
          </Box>

          {relocationData.map((data, idx) => (
            <LinkItem
              key={`relocation-${idx}`}
              href={`/vender?serviceItem=${data?._id}`}
              $isFirst={idx === 0}
            >
              {data.name}
            </LinkItem>
          ))}
        </Box>

        <Box my={7.5}>
          {deviceCleaningData.map((data, idx) => (
            <LinkItem
              key={`device-clean-${idx}`}
              href={`/vender?serviceItem=${data?._id}`}
              $isFirst={idx === 0}
            >
              {data.name}
            </LinkItem>
          ))}
          <Box color="text.minus2" my={5}>
            -
          </Box>

          {decorationData.map((data, idx) => (
            <LinkItem
              key={`decoration-${idx}`}
              href={`/vender?serviceItem=${data?._id}`}
              onClick={onSyServiceClick}
              $isFirst={idx === 0}
            >
              {data.name}
            </LinkItem>
          ))}
        </Box>
      </HelfSplitGrid>
    </Box>
  )
}

export default DesktopServiceItem
